// 스포츠 분류 통일 대상 API에서만 요청 분류값을 변경한다.
const sportsPaths = new Set(`
/api/admin/bet/betDetail /api/admin/bet/betWinList /api/admin/bet/betlistNew
/api/admin/bet/gameUse /api/admin/bet/gameUseUpdate /api/admin/gameCodes /api/admin/gameGroupCodes
/api/admin/member/create /api/admin/member/detail /api/admin/member/newUpdateRate /api/admin/member/rate
/api/admin/partnerRates /api/admin/point/botRateList /api/admin/point/pointListNew
/api/admin/report/calculateSearch /api/admin/report/dailyCalculate /api/admin/report/reportByUser
/api/admin/retail/create /api/admin/retail/partnerDetail /api/admin/retail/partnerList
/api/admin/retail/rateInfoList /api/admin/retail/rateInfoUpdate
/api/admin/setting/game/settingList /api/admin/setting/game/settingSave /api/admin/topRate
/api/bet/betDetail /api/bet/betlistNew /api/cash/rollCalculate /api/common/code /api/common/gameCodes
/api/common/gameGroupCodes /api/common/rateCategory /api/game/getGame /api/game/getGameList
/api/retail/myMemDirectList /api/retail/myMemList /api/retail/myPartnerList /api/retail/newUpdateRate /api/retail/rateInfo
/api/super/company/detail/siteGameInfo /api/super/company/modify/gameSettings /api/super/company/modify/menuSettings
/api/super/setting/gameCodeList /api/super/setting/gameCodeRegist /api/super/setting/gameCodeUpdate
/api/v2/bet/betList2 /api/v2/retail/createPartner /api/v2/retail/daily/myCalculate
/api/v2/retail/detail/rateInfo /api/v2/retail/detail/rateInfo/save /api/v2/retail/partnerInfo
`.trim().split(/\s+/))
const sportsFields = new Set(['category', 'gameCategory', 'groupCode', 'gameType', 'cateCode'])
const ratePaths = new Set(['/api/admin/member/create', '/api/admin/member/newUpdateRate', '/api/admin/retail/create', '/api/retail/newUpdateRate', '/api/v2/retail/createPartner', '/api/v2/retail/detail/rateInfo/save'])

function convertSports (value, path, key = '') {
  if (Array.isArray(value)) {
    const hasSports = key === 'rateList' && ratePaths.has(path) && value.some(item => item && item.category === 'sports')
    return value.filter(item => !hasSports || !item || item.category !== 'sport').map(item => convertSports(item, path))
  }
  if (!value || Object.prototype.toString.call(value) !== '[object Object]') {
    return sportsFields.has(key) && value === 'sport' ? 'sports' : value
  }
  return Object.fromEntries(Object.entries(value).map(([name, item]) => [name, convertSports(item, path, name)]))
}

export function normalizeSportsRequest (url, data) {
  const path = typeof url === 'string' ? url.split('?')[0] : ''
  return sportsPaths.has(path) ? convertSports(data, path) : data
}
